import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Сотрудники — MOVED to `/profile/users`.
 *
 * The roster is merchant-wide (one identity works across Eats and Доставка
 * alike), so it no longer sits under a sub-app namespace. This path forwards
 * rather than 404ing: it was an Eats nav tab, so bookmarks to it exist.
 */
export const Route = createFileRoute('/eats/users')({
  beforeLoad: () => {
    // `redirect()` is TanStack Router's control-flow throw, not an Error —
    // same exemption as `require-auth.ts`.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/profile/users', replace: true });
  },
});
